// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-puzzle-genie-login-modal {
  display: flex;
  justify-content: center;
  background-color: rgba(31, 27, 250, 0.103);
  margin: 20px;
  margin-top: 5px;
  border-radius: 10px;
  padding: 10px;
}


.public-puzzle-genie--form-title {
  font-size: x-large;
  font-weight: bold;
}

.public-puzzle-genie-login-form-description {
  font-size: x-large;
}

.public-puzzle-genie-login-form-container img{
  width:80px;
  height:80px;
  background-color: rgba(165, 165, 230, 0.432);
  padding:10px;
  border-radius: 10px;
}

.public-puzzle-genie-login-modal-login-button {
  padding: 10px;
  background-color: rgba(31, 27, 250, 0.637);
  font-weight: bold;
  color: white;
  margin: auto;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 10px;
}

.public-puzzle-genie-modal-claim-username-button:hover {
  opacity: .8;
}

@media(max-width: 500px) {
.public-puzzle-genie--form-container {
  width: 80%;
}

}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/PuzzleGenieLogin/PuzzleGenieLogin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4CAA4C;EAC5C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;AACA;EACE,UAAU;AACZ;;AAEA","sourcesContent":[".public-puzzle-genie-login-modal {\n  display: flex;\n  justify-content: center;\n  background-color: rgba(31, 27, 250, 0.103);\n  margin: 20px;\n  margin-top: 5px;\n  border-radius: 10px;\n  padding: 10px;\n}\n\n\n.public-puzzle-genie--form-title {\n  font-size: x-large;\n  font-weight: bold;\n}\n\n.public-puzzle-genie-login-form-description {\n  font-size: x-large;\n}\n\n.public-puzzle-genie-login-form-container img{\n  width:80px;\n  height:80px;\n  background-color: rgba(165, 165, 230, 0.432);\n  padding:10px;\n  border-radius: 10px;\n}\n\n.public-puzzle-genie-login-modal-login-button {\n  padding: 10px;\n  background-color: rgba(31, 27, 250, 0.637);\n  font-weight: bold;\n  color: white;\n  margin: auto;\n  margin-top: 10px;\n  width: fit-content;\n  border-radius: 10px;\n}\n\n.public-puzzle-genie-modal-claim-username-button:hover {\n  opacity: .8;\n}\n\n@media(max-width: 500px) {\n.public-puzzle-genie--form-container {\n  width: 80%;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
